/** Admin → Usage & cost (container, `billing.view`): a month's cloud production hours and estimated cost; the last 12 months to choose from. */
import { useState } from 'react';
import { useServices, useUsage } from '../../app/hooks.js';
import { UsageReport } from '../../components/admin/UsageReport.js';
import { recentMonths } from '../../lib/admin/view.js';
import { errorText } from './common.js';

export function UsageView() {
  const { nowMs } = useServices();
  const [months] = useState(() => recentMonths(nowMs(), 12));
  const [month, setMonth] = useState(months[0] ?? '');
  const usage = useUsage(month);
  return (
    <UsageReport
      months={months}
      month={month}
      usage={usage.data ?? null}
      loading={usage.isFetching}
      error={errorText(usage.error)}
      onMonthChange={setMonth}
      onRetry={() => {
        void usage.refetch();
      }}
    />
  );
}
